import { FILTER_BY } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";
import { EmployeeStatisticsReportGetterParams } from "~/entity/Employee/model/schema";
import { TStaffFilter } from "~/pages/Staff/ui/StaffFilter/model/config";
import {
  getDealerGroupFilter,
  getFiltersVal,
  resolveGroupFilter,
} from "~/shared/ui/FIlterPresets/DefaultFilterView/model/lib";

export const toServer = (
  filter: TStaffFilter
): EmployeeStatisticsReportGetterParams => {
  const itemsForService = getFiltersVal(filter.filterItems, "string");
  return {
    actualOn: dateFormat(filter.period, { type: "date-special" }),
    dealerGroup: {
      ids: [],
      cities: [],
      FOs: [],
      countries: [],
      subjects: [],
      ...getDealerGroupFilter(
        filter.filterBy?.value as keyof FILTER_BY,
        itemsForService
      ),
    },
    group: resolveGroupFilter(filter.filterBy.value as keyof FILTER_BY),
  };
};
